import { useFetchPreFillObjectDataByFormCodeMutation } from '@redux/api'

export const useFetchPreFillObjectDataWithFixedKey = (globalId: string) => {
  return useFetchPreFillObjectDataByFormCodeMutation({
    fixedCacheKey: `display-form-fetch-prefill-object-data-${globalId}`,
  })
}
